import { Outlet } from "react-router-dom"
export const GuestShellLayout = () => {

    return (
        <div className="guest-wrapper">
            <div className="guest-container">
                <Outlet/>
            </div>
        </div>
    )

}